import React from 'react';
import { Phone, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { businessInfo } from '../../data/mock';
import { useQuote } from '../../context/QuoteContext';

const CTASection = ({ 
  title = "Ready to Solve Your Plumbing Problems?",
  subtitle = "Contact our expert team today for fast, reliable plumbing services.",
  showPhone = true,
  variant = "default" // default, dark, gradient
}) => {
  const { openQuote } = useQuote();
  const bgClasses = {
    default: "bg-[#1a1a1a]",
    dark: "bg-[#0f0f0f]",
    gradient: "bg-gradient-to-r from-[#1a1a1a] to-[#2d2d2d]"
  };

  return (
    <section className={`${bgClasses[variant]} py-16 relative overflow-hidden`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#e85a24] rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#e85a24] rounded-full translate-x-1/3 translate-y-1/3 blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {title}
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            {subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            {showPhone && (
              <a href={`tel:${businessInfo.phone}`}>
                <Button 
                  size="lg" 
                  className="bg-[#e85a24] hover:bg-[#d14a14] text-white px-8 py-6 text-lg group"
                >
                  <Phone className="mr-2 group-hover:animate-pulse" size={20} />
                  Call {businessInfo.phone}
                </Button>
              </a>
            )}
            <Button 
              onClick={() => openQuote()}
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-[#1a1a1a] px-8 py-6 text-lg group"
              data-testid="cta-schedule-button"
            >
              <Calendar className="mr-2" size={20} />
              Schedule Online
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Button>
          </div>

          <p className="text-gray-400 mt-6 text-sm">
            24/7 Emergency Service Available • Free Estimates
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
